module.exports = __webpack_public_path__ + "img/portraits_18_H.a9df7833.webp";